import { styled } from '@linaria/react';
import {
  bodyFont,
  component,
  fonts,
  layout,
  primitives,
  radius,
  semantic,
  size,
  space,
} from '../../theme/tokens';

export const StyledBackButton = styled.button`
  position: absolute;
  left: ${space['space-600']};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space['space-1600']};
  height: ${space['space-1200']};
  border-radius: ${radius('button', 'radius-full')};
  border: none;
  cursor: pointer;
  padding: 0;
  color: ${semantic.icon.primary};
  -webkit-tap-highlight-color: transparent;

  svg {
    height: 11.31px;
    width: auto;
  }

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }

  &[data-variant='default'] {
    background: ${component.button.neutral.enabled.bg};

    &:hover {
      background: ${component.button.neutral.hover.bg};
    }
  }

  &[data-variant='overlay'] {
    background: ${semantic.bg.overlayBlur};
    backdrop-filter: blur(${size.blur['blur-lg']});
    top: auto;
    transform: none;

    svg {
      color: ${semantic.text.inverse};
    }

    span {
      color: ${semantic.text.inverse};
    }

    &:focus-visible {
      background: ${semantic.bg.overlayBlurStrong};
      outline-color: ${semantic.text.inverse};
    }

    &:disabled svg {
      color: ${semantic.icon.disabled};
    }

    &:hover:not(:disabled) {
      background: ${semantic.bg.overlayBlurStrong};
    }

    &:active:not(:disabled) {
      background: ${semantic.bg.overlayBlurStrong};
    }
  }

  &[data-has-label='true'] {
    @media (min-width: ${layout.desktopBreakpoint}) {
      width: auto;
      gap: ${space['space-200']};
      padding: 0 ${space['space-400']};
    }
  }

  &[data-variant='inline'] {
    position: static;
    transform: none;
    background: ${semantic.bg.surfaceSubtle};

    &:hover {
      background: ${semantic.bg.surfaceDefault};
    }
  }

  &[data-variant='contained'] {
    background: ${semantic.bg.surfaceSubtle};

    &:hover {
      background: ${semantic.bg.surfaceDefault};
    }
  }

  &:disabled {
    pointer-events: none;
    color: ${semantic.icon.disabled};
  }
`;

export const BackLabel = styled.span`
  display: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: inline;
    font-family: ${bodyFont};
    font-size: ${fonts.size.sm};
    font-weight: ${fonts.weight.medium};
    line-height: ${primitives.typography.lineHeight.normal};
    letter-spacing: ${primitives.typography.tracking.normal};
    white-space: nowrap;
    color: ${semantic.text.primary};
  }
`;
